export const contact_method = {
  type: {
    internal: 'Внутренний',
    external: 'Внешний',
    sip: 'SIP-аккаунт'
  },

  label: {
    home: 'Домашний',
    work: 'Рабочий',
    office: 'Офис'
  }
};
